import gql from 'graphql-tag'

export const QUERY_LIST_LOGS = gql`
  query OperationLogs($fieldFilters: [FieldFilter], $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    operationLogs(fieldFilters: $fieldFilters, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      operationLogs {
        _id
        user {
          _id
          name
          login
        }
        created_at
      }
    }
  }
`

export const QUERY_LOG_BY_ID = gql`
  query OperationLogById($_id: ID!) {
    operationLogById(_id: $_id) {
      _id
      user {
        _id
        name
        login
      }
      delta {
        field
        description
        old {
          value
          type
        }
        new {
          value
          type
        }
      }
      created_at
    }
  }
`
